import { Link } from 'react-router-dom'
import { Badge, getStatusBadge, Avatar } from '../ui'
import type { Job } from '../../types'
import './JobCard.css'

interface JobCardProps {
  job: Job
}

export function JobCard({ job }: JobCardProps) {
  const statusBadge = getStatusBadge(job.status)
  const deadline = job.deadline ? new Date(job.deadline) : null
  const isExpired = deadline && deadline < new Date()

  return (
    <article className="job-card">
      <Link to={`/jobs/${job.id}`} className="job-card-link">
        <div className="job-card-header">
          <div className="job-meta">
            <Badge status={statusBadge.variant}>{statusBadge.label}</Badge>
            {job.mode === 'INSTANT' && (
              <Badge variant="gold">Instant</Badge>
            )}
          </div>
          <span className="usdc-amount">${job.reward} USDC</span>
        </div>

        <h3 className="job-title">{job.title}</h3>

        <p className="job-description">
          {job.description.slice(0, 150)}
          {job.description.length > 150 ? '...' : ''}
        </p>

        {job.tags.length > 0 && (
          <div className="job-tags">
            {job.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="tag">
                {tag}
              </span>
            ))}
            {job.tags.length > 3 && (
              <span className="tag-more">+{job.tags.length - 3}</span>
            )}
          </div>
        )}

        <div className="job-footer">
          <div className="job-poster">
            <Avatar name={job.poster.name} size="sm" />
            <span>{job.poster.name}</span>
          </div>

          <div className="job-stats">
            {job._count && (
              <span className="stat">
                {job._count.applications} applicant{job._count.applications !== 1 ? 's' : ''}
              </span>
            )}
            {deadline && (
              <span className={`stat ${isExpired ? 'expired' : ''}`}>
                {isExpired ? 'Expired' : `Due ${deadline.toLocaleDateString()}`}
              </span>
            )}
          </div>
        </div>
      </Link>
    </article>
  )
}
